import { DatePicker } from '@mantine/dates';
import { IJxtDatePicker } from './types';
import { calendarCardClassNames, calendarClassNames, mergeClassNames } from './classNames';
import JxtMantineProvider from '../JxtMantineProvider';

/**
 * @param {{defaultDate?: Date; value?: Date; shadow: boolean}} props: defaultDate define the year that will be displayed initially; value current selected date, highlighted visually;shadow wheither to surround or not the calendar with a shadow
 */
const JxtDatePicker = ({ shadow = true, classNames, ...props }: IJxtDatePicker) => {
  const baseClassNames = shadow ? { ...calendarClassNames, ...calendarCardClassNames } : calendarClassNames;

  return (
    <JxtMantineProvider>
      <DatePicker {...props} type="default" classNames={mergeClassNames(baseClassNames, classNames)} />
    </JxtMantineProvider>
  );
};

export default JxtDatePicker;
